<template>
  <div :class="computedClass">
    <span
      v-if="label"
      class="jade-display-item__label"
    >
      <jade-text
        color="current-color"
        variant="text-small"
        weight="medium"
      >
        {{ label }}
      </jade-text>
      <slot
        v-if="$slots.tooltip"
        name="tooltip"
      />
    </span>
    <span class="jade-display-item__content">
      <jade-tag
        v-if="isStatus"
        size="medium"
        :solid="value?.solid"
        :variant="value?.variant"
      >
        {{ value.text }}
      </jade-tag>
      <jade-text
        v-else
        color="current-color"
        variant="display-small"
      >
        {{ value }}
      </jade-text>
    </span>
    <span
      v-if="support"
      class="jade-display-item__support"
    >
      <jade-text
        color="current-color"
        variant="text-small"
        weight="regular"
      >
        {{ support }}
      </jade-text>
    </span>
  </div>
</template>

<script>
import JadeTag from '../JadeTag'
import JadeText from '../JadeText'
import ALIGNMENT_ENUM from '../enums/alignment.enum'

export default {
  name: 'JadeDisplayItem',
  components: {
    JadeTag,
    JadeText
  },
  props: {
    label: String,
    value: [String, Object],
    support: String,
    alignment: {
      type: String,
      default: ALIGNMENT_ENUM.LEFT,
      validation: v => [ALIGNMENT_ENUM.LEFT, ALIGNMENT_ENUM.RIGHT].includes(v)
    }
  },

  computed: {
    isStatus () {
      return typeof this.value === 'object'
    },
    computedClass () {
      return {
        'jade-display-item': true,
        [`is-${this.alignment}`]: this.alignment
      }
    }
  }
}
</script>

<style scoped>
@import '@stone-payments/jade/css/display-item.css';
</style>
